/**
 * Set users full data to store
 *
 * @param {Object} state
 * @param {Object} data
 * @return {*}
 */
function sportsSetData(state, data) {
    return {
        ...state,
        ...data,
    }
}

/**
 * Set users busy into store
 *
 * @param {Object} state
 * @param {boolean} busy
 * @return {*}
 */
function sportsSetBusy(state, busy) {
    return {
        ...state,
        busy: busy,
    }
}

/**
 * @param {Object} state
 * @param {Object} action
 * @return {*}
 */
export default function (state = [], action) {
    switch (action.type) {
        case 'SPORTS_SET_DATA': return sportsSetData(state, action.data)
        case 'SPORTS_SET_BUSY': return sportsSetBusy(state, action.busy)
        default: return state
    }
}
